export const focusInCurrentTarget = ({ relatedTarget, currentTarget }) => {
  if (relatedTarget === null) return false

  let node = relatedTarget.parentNode

  while (node !== null) {
    if (node === currentTarget) return true
    node = node.parentNode
  }

  return false
}

export const booleanStringIsTruthy = (value: string) => value === 'true'

export const formatCurrency = (amount) => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  })

  return formatter.format(amount)
}

export const relativeDate = (date) => {
  const formatter = new Intl.RelativeTimeFormat('en', {
    style: 'long',
    numeric: 'auto',
  })
  const now = new Date().getTime()
  const then = new Date(date).getTime()
  const difference = then - now
  const days = Math.round(difference / (1000 * 3600 * 24))

  return formatter.format(days, days > 30 ? 'month' : 'day')
}

export const roundHalf = (num) => {
  if (!num) return 0
  return Math.round(num * 2) / 2
}

export const handleize = (str) => {
  if (!str) return ''
  return str
    .replace(/\s+/g, '-')
    .replace(/[^a-zA-Z0-9-]/g, '')
    .toLowerCase()
}

export const parseGid = (id) => {
  if (!id || typeof id !== 'string') return id
  return id.replace('gid://shopify/Product/', '')
}

export const lerp = (a, b, n) => (1 - n) * a + n * b

export const clamp = (num, min, max) => Math.min(Math.max(num, min), max)

export const formatVideoTime = (time) => {
  const minutes = Math.floor(time / 60)
  const seconds = Math.floor(time - minutes * 60)
  const formattedSeconds = seconds < 10 ? `0${seconds}` : seconds
  return `${minutes}:${formattedSeconds}`
}

export const getUrlFromLink = (link) => {
  if (!link) return null
  if (link.type === 'external') {
    return link.url
  }

  if (link.type === 'internal' && link.to) {
    switch (link.to._type) {
      case 'homePage':
        return '/'
      case 'page':
        return `/${link.to.slug.current}`
      case 'helpPage':
        return `/help/${link.to.slug.current}`
      case 'product':
        return `/products/${link.to.slug.current}`
      case 'collection':
        return `/collections/${link.to.store.slug.current}`
      case 'worldPage':
        return '/world'
      default:
        return `/${link.to.slug.current}`
    }
  }

  return null
}

export const secondsToHms = (seconds) => {
  if (!seconds) return '00:00'

  const d = Number(seconds)
  const h = Math.floor(d / 3600)
  const m = Math.floor((d % 3600) / 60)
  const s = Math.floor((d % 3600) % 60)

  const hDisplay = h > 0 ? `${h}:` : ''
  const mDisplay = m > 0 ? `${m}:` : '0:'
  const sDisplay = s > 0 ? `${s}` : '00'
  return hDisplay + mDisplay + sDisplay
}

export const formattedPuslishDate = (date) => {
  if (!date) return ''
  const rawDate = new Date(date)
  const DAY_MILLISECONDS = 1000 * 60 * 60 * 24

  const rtf = new Intl.RelativeTimeFormat('en', {
    numeric: 'auto',
  })
  const daysDifference = Math.round(
    (rawDate.getTime() - new Date().getTime()) / DAY_MILLISECONDS
  )

  return rtf.format(daysDifference, 'day')
}

export const move = (array, moveIndex, toIndex) => {
  const item = array[moveIndex]
  const length = array.length
  const diff = moveIndex - toIndex

  if (diff > 0) {
    // move left
    return [
      ...array.slice(0, toIndex),
      item,
      ...array.slice(toIndex, moveIndex),
      ...array.slice(moveIndex + 1, length),
    ]
  } else if (diff < 0) {
    // move right
    const targetIndex = toIndex + 1
    return [
      ...array.slice(0, moveIndex),
      ...array.slice(moveIndex + 1, targetIndex),
      item,
      ...array.slice(targetIndex, length),
    ]
  }
  return array
}

export const randomNumberBetween = (min, max) =>
  Math.floor(Math.random() * (max - min + 1) + min)
